import React from 'react';
import { ClarovideoLogo } from 'components/ClarovideoLogo';
import { BackChevron } from '../BackChevron';
import { useActiveBackNavigationStep } from '../BackNavigation';
import './style.scss';

// `onBack`/`showBack` son el default del flujo (volver a la lista, o salir a
// la app). Si hay un paso interno anotado (editar, detalle de tarjeta,
// detalle de cuenta PayPal...) su back manda: es el más específico. Esto
// solo aplica cuando `respectActiveStep` es true (angosto): ahí lista y
// detalle son la misma columna apilada, así que fusionar evita dos chevrones
// pegados uno debajo del otro. En ancho (desktop), lista y detalle son dos
// columnas separadas — ahí este Header ignora el paso activo a propósito
// (`respectActiveStep={false}`) y es `ActiveStepBackChevron`, dentro del
// panel de detalle, quien lo resuelve como un chevron propio de esa columna.
export const Header = ({ onBack, showBack = true, respectActiveStep = true }) => {
  const activeBackNavigationStep = useActiveBackNavigationStep();
  const activeStepBack = respectActiveStep ? activeBackNavigationStep : null;
  const effectiveOnBack = activeStepBack ?? onBack;
  const effectiveShowBack = showBack || Boolean(activeStepBack);

  return (
    <div className="QRLinkingPaymentMethodHeader">
      <ClarovideoLogo
        width={157}
        height={32}
        classNames="QRLinkingPaymentMethodHeader__logo"
        redirectOnClick={false}
      />
      {effectiveShowBack && <BackChevron onClick={effectiveOnBack} />}
    </div>
  );
};

export default Header;
